module.exports = __webpack_public_path__ + "static/img/UTM老师_陈东尔.d6d8d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_陈东尔.png
// module id = JSZf
// module chunks = 0